export const isNumber = (value: unknown): boolean => {
  return !isNaN(Number(value));
};

export const getNumberFromString = (str: string) => {
  return parseInt(str.replace(/[^\d.]/g, ""));
};
